import { configureChains, createConfig } from 'wagmi';
import { publicProvider } from 'wagmi/providers/public';
import { connectorsForWallets } from '@rainbow-me/rainbowkit';
import {
  injectedWallet,
  rabbyWallet,
  rainbowWallet,
  metaMaskWallet,
  coinbaseWallet,
  walletConnectWallet,
  safeWallet,
} from '@rainbow-me/rainbowkit/wallets';

import { APP_CHAINS } from './chains';

// WalletConnect Cloud project ids are 32 hex chars; anything else (unset, or the
// `projecId` placeholder) makes the relay reject the socket with code 3000.
const WALLETCONNECT_PROJECT_ID = /^[0-9a-f]{32}$/i;

export const getWagmiConfig = () => {
  const projectId = process.env.NEXT_PUBLIC_PROJECT_ID;
  const hasWalletConnect = !!projectId && WALLETCONNECT_PROJECT_ID.test(projectId);

  if (!hasWalletConnect) {
    console.warn(
      'NEXT_PUBLIC_PROJECT_ID is missing or invalid; WalletConnect wallets are disabled. ' +
        'Browser-extension wallets and guest join still work. Set it in im3Client/.env and rebuild.',
    );
  }

  const { chains, publicClient } = configureChains(APP_CHAINS, [publicProvider()]);

  const connectors = connectorsForWallets([
    {
      groupName: 'Popular',

      wallets: hasWalletConnect
        ? [
            injectedWallet({ chains }),
            metaMaskWallet({ projectId: projectId!, chains }),
            rabbyWallet({ chains }),
            walletConnectWallet({ projectId: projectId!, chains }),
          ]
        : [injectedWallet({ chains }), rabbyWallet({ chains })],
    },
    {
      groupName: 'Others',
      wallets: hasWalletConnect
        ? [
            coinbaseWallet({ chains, appName: 'IM3' }),
            rainbowWallet({ projectId: projectId!, chains }),
            safeWallet({ chains }),
          ]
        : [coinbaseWallet({ chains, appName: 'IM3' }), safeWallet({ chains })],
    },
  ]);

  return {
    wagmiConfig: createConfig({
      autoConnect: true,
      connectors,
      publicClient,
    }),
    chains,
  };
};
